const routes = {
  root: '/proxyRedirect',
}

export default routes
